#InteractiveVideoComponent = require('../components/interactive-video').default

class window.InteractiveWindow
  constructor: (@interactiveWindow, @elementForLoadAnimation)->
    @numbersAnimationContainer = false
    @modelAnimate = false
    @lastScroll = $(window).scrollTop()
    @interactiveWindowNumber = 0
    @lastInteractiveWindowNumber = 0
    @interactiveWindowCount = $('.interactive-window-item[data-interactive-window-index]').length
    @scrollFlag = true
    @interactiveWindowItems = $('.interactive-window-item[data-interactive-window-index]')
    @interactiveWindowContainers = @interactiveWindowItems.find('.interactive-window__model')
    @countWindows = $('.interactive-window-item[data-tab-index]').length
    @init()


  init: ->
    if window.innerWidth > 1104
      @loadAnimation()

    @initInteractiveWindowMenu()
    if @interactiveWindowCount
      $('.two-window-switch__counter-max').html('0'+@interactiveWindowCount)
    else
      $('.two-window-switch__counter-max').html(@interactiveWindowCount)

  initInteractiveWindowMenu: ->
    self = this

    # Клик на стрелку вправо на втором экране
    $('.js-next-window').click ->
      self.interactiveWindowNumber += 1
      $(this).removeClass('hidden_element')
      $('.js-previous-window').removeClass('hidden_element')

      if self.interactiveWindowNumber == self.interactiveWindowCount - 1
        $(this).addClass('hidden_element')
      else
        $(this).removeClass('hidden_element')

      $(self.interactiveWindowItems).removeClass('active')

      # Проходим по всем интерактивным экранам и делаем их активными
      for windowItem in $(self.interactiveWindowItems)
        $(windowItem).addClass('active')

        interactiveWindowIndex = $(windowItem).data('interactive-window-index')

        # Прерываем цикл на выбранном экране
        if interactiveWindowIndex == self.interactiveWindowNumber
          break
      # Запускаем анимацию при загрузке экрана
      self.loadAnimation()

      currentNumber = self.interactiveWindowNumber + 1
      # Меняем номер в счетчике
      if currentNumber < 10
        $('.js-current-window').html('0'+currentNumber);
      else
        $('.js-current-window').html(currentNumber);

    # Клик на стрелку влево на втором экране
    $('.js-previous-window').click ->
      self.interactiveWindowNumber -= 1
      $(this).removeClass('hidden_element')
      $('.js-next-window').removeClass('hidden_element')

      if self.interactiveWindowNumber == 0
        $(this).addClass('hidden_element')
      else
        $(this).removeClass('hidden_element')

      $(self.interactiveWindowItems).removeClass('active')

      # Проходим по всем интерактивным экранам и делаем их активными
      for windowItem in $(self.interactiveWindowItems)
        $(windowItem).addClass('active')

        interactiveWindowIndex = $(windowItem).data('interactive-window-index')

        # Прерываем цикл на выбранном экране
        if interactiveWindowIndex == self.interactiveWindowNumber
          break
      # Запускаем анимацию при загрузке экрана
      self.loadAnimation()

      currentNumber = self.interactiveWindowNumber + 1
      # Меняем номер в счетчике
      if currentNumber < 10
        $('.js-current-window').html('0'+currentNumber);
      else
        $('.js-current-window').html(currentNumber);


  windowItemChange: (@interactiveWindowNumber, deltaY = 0)->
    self = this
    # Изменение активного экрана
    if self.interactiveWindowNumber < (@countWindows - 1) || (deltaY < 0 && $(window).scrollTop() == 0)
      self.calculateInteractiveWindowNumber(deltaY)
      $('.two-window-tabs__item').removeClass('two-window-tabs__item--active')
      $(".two-window-tabs__item[data-interactive-window-index=#{self.interactiveWindowNumber}]").addClass('two-window-tabs__item--active')

      self.loadAnimation()

  # Определяем какой экран нужно показать следующим
  calculateInteractiveWindowNumber: (deltaY)->
    if deltaY > 0
      @interactiveWindowNumber += 1
      $(@interactiveWindowItems.get(@interactiveWindowNumber)).addClass('active')
    else
      if @interactiveWindowNumber > 0
        @interactiveWindowItems.removeClass('active')
        $(@interactiveWindowItems.get(0)).addClass('active')
        @interactiveWindowNumber = 0


  getElementsForAnimation: (container, windowNumber)->
    return container.find('.animate').filter ->
      windowBlockIndex = $(this).data('interactive-window-block-index') * 1 || 1
      return windowBlockIndex <= windowNumber || windowBlockIndex == 1


  revertAnimateContent: (container, delay = 0)->
    windowNumber = @interactiveWindowNumber
    elements = @getElementsForAnimation(container, @lastInteractiveWindowNumber)
      .filter ->
        if $(this).data('animate-once')
          return false
        windowBlockIndex = $(this).data('interactive-window-block-index') * 1 || 1
        return windowBlockIndex > windowNumber || windowBlockIndex == 1

    for element, index in elements.get().reverse()
      # FIXME: refactor to functions, remove from the global scope:
      window.Animations.animateElementRevert(element, index, 50, @elementForLoadAnimation)


  animateContent: (container, delay = 0)->
    className = @elementForLoadAnimation
    elements = @getElementsForAnimation(container, @interactiveWindowNumber)
      .filter -> return $(this).hasClass(className)

    for element, index in elements
      # FIXME: refactor to functions, remove from the global scope:
      window.Animations.animateElement(element, index, 50, @elementForLoadAnimation)


  # Анимация загрузки
  loadAnimation: ->
    self = this
    topWindow = $('.interactive-window-item--top')
    # Animate the main content:
    @animateContent(topWindow)

    root = $(@interactiveWindowItems.get(@interactiveWindowNumber))

    @interactiveWindowContainers.addClass('active').removeClass('interactive')
#    container = root.find('.interactive-window__model')
    @interactiveWindowItems.off('transitionend')

    animatingRoot = root
    lastRoot = $(@interactiveWindowItems.get(@lastInteractiveWindowNumber))
    if @lastInteractiveWindowNumber != @interactiveWindowNumber
      # Restore css classes with transforms
      @revertAnimateContent(topWindow)
      @revertAnimateContent(lastRoot)

#    if @lastInteractiveWindowNumber > @interactiveWindowNumber
#      animatingRoot = lastRoot
#    else if @lastInteractiveWindowNumber == @interactiveWindowNumber
#      # Animate right content on the page load:
#      setTimeout(
#        ->
#          self.animateContent(root)
#      ,1000)

    self.animateContent(root)
    @lastInteractiveWindowNumber = @interactiveWindowNumber






// WEBPACK FOOTER //
// ./assets/javascripts/app/interactive_window.coffee